import { BrowserRouter } from 'react-router-dom';
import Toast from './components/commonComponents/toast/ToastWrapper';
import Router from './routes/Index';
import { NotificationProvider } from './providers/NotificationProvider';
import { SocketProvider } from './providers/SocketProvider';

function App() {
  return (
    <SocketProvider>
      <NotificationProvider>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
        <Toast />
      </NotificationProvider>
    </SocketProvider>
  );
}

export default App;
